import React, { Component } from "react";
import PropTypes from 'prop-types';
// @material-ui/core components
import { withStyles } from "@material-ui/styles";
import Modal from "@material-ui/core/Modal";
import DialogContent from '@material-ui/core/DialogContent';
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Table from "components/Table/Table.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import Button from "components/CustomButtons/Button.js";
// services
import activityService from "services/activity.service";
import unityService from "services/unity.service";
// management imports 
import CadastrarQuestoes from "./Cadastrar";
import EditarQuestoes from "./Editar";
import DeletarQuestoes from "./Deletar";


const styles = theme => ({
 	cardCategoryWhite: {
		"&,& a,& a:hover,& a:focus": {
			color: "rgba(255,255,255,.62)",
			margin: "0",
			fontSize: "14px",
			marginTop: "0",
			marginBottom: "0"
		},
		"& a,& a:hover,& a:focus": {
			color: "#FFFFFF"
		}
  	},
	cardTitleWhite: {
		color: "#FFFFFF",
		marginTop: "0px",
		minHeight: "auto",
		fontWeight: "300",
		fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
		marginBottom: "3px",
		textDecoration: "none",
		"& small": {
			color: "#777",
			fontSize: "65%",
			fontWeight: "400",
			lineHeight: "1"
		}
	}
});

class GerenciarQuestoes extends Component {
    constructor(props) {
        super(props);
		this.state = {activities: [], show: "", activityEdit: "", units: []};
		this.handleSearch();

    }

    handleOpenCreate = () => {
      	this.setState({ show: "create" });
	};

	handleOpenEdit = (activity) => {
		this.setState({ show: "edit", activityEdit: activity });
	};

	handleOpenDelete = (activity) => {
		this.setState({ show: "delete", activityEdit: activity });
	};

	handleSearch() {
		activityService.listAllActivities().then(activities => {
			const tableActivities = []
			activities.forEach(activity => {
				tableActivities.push([
					activity.key,
					(activity.type === 'multiplechoice' ? 'Multipla Escolha' : activity.type === 'fillsentence' ? 'Completar Frase' : activity.type === 'draganddrop' ? 'Arrasta e Solta' : activity.type === 'audiochoice' ? 'Questão com Áudio' : "---"), 
					activity.unity, 
					<Button color="primary" type="submit" round onClick={(event) => {this.handleOpenEdit(activity)}}>Editar</Button>,
					<Button color="primary" type="submit" round onClick={(event) => {this.handleOpenDelete(activity.key)}}>Excluir</Button>
			  	])
			})
			this.setState({activities: tableActivities})

			unityService.listAllUnits().then(units => {
				const tableUnits = [];
				units.forEach(unity => tableUnits.push({key: unity.key, value: unity.key, label: `${unity.key} - ${unity.title}`}));
				this.setState({units: tableUnits})
			})
		})
	}

    render() {
        const { classes } = this.props;
        return (
          	<GridContainer>
				<GridItem xs={12} sm={12} md={12}>
					<Button color="primary" type="submit" round onClick={this.handleOpenCreate}>Cadastrar Atividade</Button>
				</GridItem>
            	<GridItem xs={12} sm={12} md={12}>
              		<Card>
						<CardHeader color="primary">
							<h4 className={classes.cardTitleWhite}>Lista de Atividades</h4>
							<p className={classes.cardCategoryWhite}>
								Lista para visualização e gerenciamento das Atividades Extras
							</p>
						</CardHeader>
                		<CardBody>
							<Table
								tableHeaderColor="primary"
								tableHead={["ID da Atividade", "Tipo de Atividade", "ID da Unidade", "Editar", "Excluir"]}
								tableData={this.state.activities}
							/>
                		</CardBody>
              		</Card>
            	</GridItem>
				<Modal open={this.state.show === 'create'} onClose={() => {this.setState({show: ""}); this.handleSearch()}} aria-labelledby="simple-modal-title" aria-describedby="simple-modal-description">
					<DialogContent>
						<CadastrarQuestoes units={this.state.units} onClose={() => {this.setState({show: ""}); this.handleSearch()}} />
					</DialogContent>
				</Modal>
				<Modal open={this.state.show === 'edit'} onClose={() => {this.setState({show: ""}); this.handleSearch()}} aria-labelledby="simple-modal-title" aria-describedby="simple-modal-description">
					<DialogContent>
						<EditarQuestoes activity={this.state.activityEdit} units={this.state.units} onClose={() => {this.setState({show: ""}); this.handleSearch()}}/>
					</DialogContent>
				</Modal>
				<Modal open={this.state.show === 'delete'} onClose={() => {this.setState({show: ""}); this.handleSearch()}} aria-labelledby="simple-modal-title" aria-describedby="simple-modal-description">
					<DialogContent>
						<DeletarQuestoes activity={this.state.activityEdit} onClose={() => {this.setState({show: ""}); this.handleSearch()}}/>
					</DialogContent>
				</Modal>
          	</GridContainer>
        );
    };
}

GerenciarQuestoes.propTypes = {
    classes: PropTypes.object.isRequired,
};
  
export default withStyles(styles)(GerenciarQuestoes);